/**
 * @author lantian
 * @description 全局变量模块维护
 */

type TVars = {
  // 用于代理配置、转发
  PROXY_API: string
  // 后台地址
  PROXY_HTTPS: string
  // 前缀，默认配置
  PREFIX: string
  // 组织编码
  ORG_CODE: string
  // 组织 名称
  ORG_NAME: string
  // 接口上下文
  API_CONTEXT: string
  /**
   * 功能：分页配置
   */
  PAGE: {
    pageNo: number
    pageSize: number
    pageSizeOptions: Array<string>
    defaultPageSize: number
  }
}

export const VARS: TVars = {
  PROXY_API: import.meta.env.VITE_PROXY_API,

  PROXY_HTTPS: import.meta.env.VITE_HTTP,

  PREFIX: 'xh',

  ORG_CODE: 'xh',

  ORG_NAME: '新华书店',

  API_CONTEXT: '/api',

  PAGE: {
    pageNo: 1,
    pageSize: 20,
    pageSizeOptions: [10, 30, 50, 100, 200].map(String),
    defaultPageSize: 10,
  },
}
